import { TRACKING_ACTIONS, TRACKING_ELEMENT_TYPES, trackEvent } from '@medflex/utils/Tracking';
import makeApiRequest from '../../../api/makeApiRequest';

const patientInvitations = {
  name: 'patientInvitations',
  state: {},
  effects: dispatch => ({
    async invite(payload, { oidcSession }) {
      dispatch.errors.remove({ realm: 'patient_invitations', type: 'invite' });

      const url = '/patient-invitations';
      const body = {
        data: {
          type: 'patient-invitations',
          attributes: payload,
        },
      };
      const [request] = makeApiRequest({ url, method: 'post', data: body }, oidcSession);
      const { error } = await request;
      if (error) dispatch.errors.add({ realm: 'patient_invitations', type: 'invite', error });
    },
    async connect(payload, { oidcSession }) {
      dispatch.errors.remove({ realm: 'patient_invitations', type: 'connect' });
      const { contactId, permanentId } = payload;
      const url = `/patient-invitations/${contactId || permanentId}`;
      const body = {
        data: {
          type: `patient-invitations${permanentId ? '-permanent' : ''}`,
          attributes: {
            id: contactId || permanentId,
          },
        },
      };
      const [request] = makeApiRequest({ url, method: 'patch', data: body }, oidcSession);
      const { error, status } = await request;

      // 409 means already connected, which
      // is considered a successful invitation
      if (error && status !== 409)
        dispatch.errors.add({ realm: 'patient_invitations', type: 'connect', error });

      dispatch.chatContacts.refresh();
    },
    async delete({ contactId }, { oidcSession }) {
      const url = `/patient-invitations/${contactId}`;

      const [request] = makeApiRequest({ url, method: 'delete' }, oidcSession);
      const { error } = await request;

      if (!error) {
        trackEvent({
          zone: 'Contacts',
          action: TRACKING_ACTIONS.CLICK,
          elementType: TRACKING_ELEMENT_TYPES.BUTTON,
          actionText: 'Delete Invitation - Success',
        });
        return;
      }

      trackEvent({
        zone: 'Contacts',
        action: TRACKING_ACTIONS.CLICK,
        elementType: TRACKING_ELEMENT_TYPES.BUTTON,
        actionText: 'Delete Invitation - Failed',
      });
      throw error;
    },
    async resend({ contactId }, { oidcSession }) {
      const url = `/patient-invitations/${contactId}/resend`;
      const [request] = makeApiRequest({ url, method: 'patch' }, oidcSession);
      const { error } = await request;

      if (!error) {
        trackEvent({
          zone: 'Contacts',
          action: TRACKING_ACTIONS.CLICK,
          elementType: TRACKING_ELEMENT_TYPES.BUTTON,
          actionText: 'Resend Invitation - Success',
        });
        return;
      }

      trackEvent({
        zone: 'Contacts',
        action: TRACKING_ACTIONS.CLICK,
        elementType: TRACKING_ELEMENT_TYPES.BUTTON,
        actionText: 'Resend Invitation - Failed',
      });
      throw error;
    },
  }),
};

export default patientInvitations;
